import { getConciliationAmountLimit } from '../../utils/conciliationAmountLimit'

import Slider from '@mui/material/Slider'
import { useContext, useEffect, useState } from 'react'
import TablaAdmVinculacion from './TableAdmVinculacion'
import CustomButton from '../ui/CustomButton'
import { Box, Dialog, DialogActions, DialogContent, IconButton } from '@mui/material'
import { Title } from '../ui/index'
import ArrowIcon from '@mui/icons-material/KeyboardArrowUpOutlined'
import DownIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import GlobalContext from '../../../context/global-context'
import { OrganizationAPI } from '../../../api/organization.api'
import FilterDateControl from '../table/FilterDateControl'
import dayjs from 'dayjs'

const InputField = ({ label, placeholder, type, value, onChange }) => (
  <div>
    <label className='block text-sm font-medium text-gray-700'>{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className='mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
    />
  </div>
)

const ModalAdmVinculacion = ({ open, setOpen, type, idPrincipal, dataLinkage, montoTotal }) => {
  const amountLimit = getConciliationAmountLimit(montoTotal)
  const [value, setValue] = useState([1, amountLimit])
  const [showFilters, setShowFilters] = useState(true)
  const [data, setData] = useState([])
  const { ui, currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [, setMonthFilter] = useState(dayjs().format('MM'))
  const [, setYearFilter] = useState(dayjs().format('YYYY'))
  const [filters] = useState({
    fechaInicio: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaFin: dayjs().format('YYYY-MM-DD'),
  })
  const [tempFilters, setTempFilters] = useState({ ...filters })
  const [selectedIds, setSelectedIds] = useState([])
  const [searchKeyword, setSearchKeyword] = useState('')
  const [selectedBank, setSelectedBank] = useState('')
  const [bancosUnicos, setBancosUnicos] = useState([])

  useEffect(() => {
    setValue([1, amountLimit])
  }, [amountLimit, open])

  const handleClose = () => setOpen(false)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleCheckboxChange = (ids) => {
    setSelectedIds(ids)
  }

  const functionGetData = async () => {
    try {
      ui.setLoader({ visible: true})
      const response = await organizationAPI.getListaParaVincular({
        businessId: currentBusiness.id, 
        idLibro: idPrincipal,
        from: tempFilters.fechaInicio,
        to: tempFilters.fechaFin,
        amountFrom: value[0],
        amountTo: value[1], 
        limit: 10000,
      })
      setData(response.data)
      const bancos = Array.from(
        new Set(
          response.data
            .map((item) => item.nombreCuentaBanco)
            .filter((nombre) => nombre && nombre !== 'Caja Principal')
        )
      )
  
      // Agregar 'Caja Principal' manualmente al inicio
      setBancosUnicos(['Caja Principal', ...bancos])
  
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false })
    }
  }

  useEffect(() => {
    functionGetData()
  }, [tempFilters, value])

  const handleConciliarMovimientos = async () => {
    const payload = {
      ids: selectedIds.map(Number)
    }
    try {
      ui.setLoader({ visible: true})
      await organizationAPI.postListaVincular({
        businessId: Number(currentBusiness.id),
        idLibro: idPrincipal,
      },payload)
      handleClose()
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false })
    }
  }

  const handleDateChange = (key, newValue) => {
      const newDate = dayjs(newValue)
      setTempFilters((prev) => ({
        ...prev,
        [key]: newDate.format('YYYY-MM-DD'),
      }))
      
      // Solo actualizar month y year cuando cambia la fecha de inicio
      if (key === 'fechaInicio') {
        setMonthFilter(newDate.format('MM'))
        setYearFilter(newDate.format('YYYY'))
      }
    }

  const filteredRows = (data || []).filter((item) => {
    const matchesKeyword = item.descripcion?.toLowerCase().includes(searchKeyword.toLowerCase())
    const matchesBank = selectedBank ? item.nombreCuentaBanco === selectedBank || selectedBank === 'Caja Principal' : true
    return matchesKeyword && matchesBank
  })

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      maxWidth='lg'
      scroll='body'
      PaperProps={{
        sx: {
          backgroundColor: '#f2f2f2',
          borderRadius: '8px',
          padding: '16px',
        },
      }}
    >
      <DialogContent>
      <div className='relative w-full flex justify-end'>
        <IconButton
          onClick={() => setShowFilters(!showFilters)}
        >
          {showFilters ? <ArrowIcon /> : <DownIcon />}
        </IconButton>
      </div>
      {type === 'venta' ? (<Title className='text-3xl mb-4'>Movimientos por Abono</Title>) : (<Title className='text-3xl mb-4'>Movimientos por Carga</Title>)}
        {showFilters && (
          <div className='p-4 bg-white rounded-lg shadow-md mb-10'>
            <div className='grid grid-cols-3 gap-4'>
              <InputField label='Palabra Clave' placeholder='LIPSUM' type='text' value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)}/>
                <div className="flex p-6 space-x-4 ">
                  <FilterDateControl
                    label="Fecha Desde"
                    value={tempFilters.fechaInicio}
                    onChange={(newValue) => handleDateChange("fechaInicio", newValue)}
                  />
                  <FilterDateControl
                    label="Fecha Hasta"
                    value={tempFilters.fechaFin}
                    onChange={(newValue) => handleDateChange("fechaFin", newValue)}
                  />
                </div>
              <div>
                <label className='block text-sm font-medium text-gray-700'>Monto</label>
                <Box sx={{ width: '100%' }}>
                  <div className='flex justify-between text-sm text-gray-500 mb-1'>
                    <span>${value[0].toLocaleString()}</span>
                    <span>${value[1].toLocaleString()}</span>
                  </div>
                  <Slider
                    getAriaLabel={() => 'Monto range'}
                    value={value}
                    onChange={handleChange}
                    valueLabelDisplay='off'
                    min={0}
                    max={amountLimit}
                  />
                </Box>
              </div>
              <div>
                <label className='block text-sm font-medium text-gray-700'>Banco</label>
                <select
                  className='mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                  value={selectedBank}
                  onChange={(e) => setSelectedBank(e.target.value)}
                >
                  <option value=''>Todos los bancos</option>
                  {bancosUnicos.map((bank, i) => (
                    <option key={i} value={bank}>{bank}</option>
                  ))}
                </select>
              </div>
              <InputField label='Contraparte' placeholder='Inversiones Ultramar Ltda.' type='text' />
              <InputField label='RUT' placeholder='11.111.111-1' type='text' />
            </div>
          </div>
        )}
        <Title className='text-2xl mb-4'>Sugerencias</Title>
        <div className='p-4 rounded-lg shadow-md bg-white'>
          <div className='overflow-x-auto'>
            <TablaAdmVinculacion
              onCheckboxChange={handleCheckboxChange}
              rows={filteredRows}
              idPrincipal={idPrincipal}
              dataLinkage={dataLinkage}
              montoMode={type === 'venta' ? 'abono' : 'cargo'}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton color='accent2' className='rounded-full' title='CONCILIAR MOVIMIENTOS' onClick={handleConciliarMovimientos} />
        <CustomButton color='primary' onClick={handleClose} className='rounded-full' title='CANCELAR' />
      </DialogActions>
    </Dialog>
  )
}

export default ModalAdmVinculacion
